import { AppLayout } from '@/layouts/AppLayout'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authRoutes/_appWrapper')({
  component: RouteComponent,
})

function RouteComponent() {
  return <AppLayout />
}
